import axios from "axios";

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    return response;
  },
  function(error) {
    // 对响应错误做点什么
    // alert(`接口调用失败！\n 原因：${error}`)
    return Promise.reject(error);
  }
);

async function request(option) {
  try {
    const hideErrorTip = option.data && option.data.hideErrorTip;
    if (hideErrorTip) {
      delete option.data.hideErrorTip;
    }
    const response = await axios(option).catch(function(error) {
      if (hideErrorTip) {
        return;
      }
      if (error.response) {
        // 请求已发出，但服务器响应的状态码不在 2xx 范围内
        const { errorMessage } = error.response.data || {};
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        alert(`网络异常！\n errorMessage： ${errorMessage}`);
        return error.response;
      } else if (error.message) {
        // Something happened in setting up the request that triggered an Error
        alert(`网络异常！\n errorMessage： ${error.message}`);
        console.log("Error", error.message);
      } else {
        alert(`网络异常！\n error：  ${error}`);
        console.log(error);
      }
    });
    if (response && response.status === 200) {
      if (response.data) {
        // console.log('response.data', response.data)
        return response.data;
      } else {
        return response;
      }
    }
  } catch (error) {
    console.log("catch error", error);
  }
}

export default request;



// WEBPACK FOOTER //
// ./src/request.js